module.exports = __webpack_public_path__ + "media/images/marketing-banner/logo-6bd9dff868eb6b9ffac266380bbc8ed3.png";